/**
 * User Preferences Service (Web)
 *
 * Handles API calls to GET/PATCH user preferences, including locale settings.
 */
import { apiClient } from './apiClient';

/** UI settings within user preferences */
export interface UiSettings {
  language?: string;
  theme?: string;
  sidebarCollapsed?: boolean;
}

/** Full user preferences response */
export interface UserPreferencesResponse {
  userId: string;
  settings: {
    carouselCompleted?: boolean;
    ui?: UiSettings;
  };
  updatedAt: string;
}

/** Partial update payload for PATCH */
export interface UpdateUserPreferencesPayload {
  ui?: {
    language?: string;
    theme?: string;
    sidebarCollapsed?: boolean;
  };
}

/** Get user preferences from the API. */
export const getPreferences = () =>
  apiClient.get<UserPreferencesResponse>('/api/v1/users/preferences');

/** Update user preferences (partial merge). */
export const updatePreferences = (
  partial: UpdateUserPreferencesPayload,
) =>
  apiClient.patch<UserPreferencesResponse>('/api/v1/users/preferences', partial);
